import moment from 'moment'
import jwtDecode  from 'jwt-decode';
import { DONE_REFRESHING_TOKEN, 
    REFRESHING_TOKEN, 
    AUTHENTICATION_ADDUPDATE_TOKEN,
    REFRESHING_TOKEN_ERROR } from '../actions/refreshToken'

import { LOGINSTATE_LOGOUT } from '../actions/login'    
import { API_URL } from '../actions/application';


export function refreshToken(dispatch, rToken) {

    var freshTokenPromise = fetchJWTToken(dispatch, rToken)
        .then(data => {     

            dispatch({type: AUTHENTICATION_ADDUPDATE_TOKEN, data});
            dispatch({type: DONE_REFRESHING_TOKEN});

            return data.token ? Promise.resolve(data.token) : Promise.reject({
                    message: 'could not refresh token'
            });

        })
        .catch(e => {
            // console.log('error refreshing token', e);
            dispatch({type: REFRESHING_TOKEN_ERROR});
            return Promise.reject(e);
        });

    dispatch({
        type: REFRESHING_TOKEN,
        freshTokenPromise
    });

    return freshTokenPromise;
}

export function fetchJWTToken(dispatch, rToken) {
    // console.log('executing fetchJWTToken')   
    // return fetch('http://api.kasvurahoitus.fi/api/Authentication/RefreshToken?rToken='+rToken)
    return fetch(API_URL+'api/Authentication/RefreshToken?rToken='+rToken)
    .then (
        response => {
            if (!response.ok) {
                // console.log('no token')   
                throw "no token";
            }

            return response.json().then (
                data => {    
                    // console.log('got new token');
                    // console.log(response);
                    return data;                    
                }                     
            )                                
    }) 
}

export function jwt({ dispatch, getState }) {    
        return (next) => (action) => {

        if (typeof action === 'function') {            
            // console.log('in middleware action')
            if (getState().auth && getState().auth.token) {
                // console.log('has token')
               

                let currToken = getState().auth.token;               
                let tokenExp = jwtDecode(currToken).exp;
                var rToken = getState().auth.refreshToken;
                    // console.log('token exp:'+tokenExp);
                    // console.log(moment(tokenExp*1000).format('MMMM Do YYYY, h:mm:ss a'));
                    // console.log(moment(Date.now()).format('MMMM Do YYYY, h:mm:ss a'));

                    if (moment(tokenExp*1000) - moment(Date.now()) < 5000) {                            
                        // console.log('fetching new token')    
                    // make sure we are not already refreshing the token
                    let p = getState().auth.freshTokenPromise;
                    // console.log('heres the promise:');
                    // console.log(p);
                    if (!p) {
                        return refreshToken(dispatch, rToken).then(() => next(action));
                    } else {                        
                        return p.then(() => next(action));
                    }

                    }
                    else                         
                       {} // console.log('NOT fetching new token')               
            }
        }

        return next(action);
    };
}